import { TRACK_IDS } from '@edulastic/constants/educationJoyrides'
import { buildJoyrideBulletBody } from './constants'
import {
  CurriculumModerateIcon,
  DifferentiatedGroupsModerateIcon,
  DistrictLibraryModerateIcon,
  GenAiModerateIcon,
} from './icons/ModerateJoyrideIcons'

export const MODERATE_TRACK_CONTENT = {
  [TRACK_IDS.SEARCH_DISTRICT_LIBRARY]: {
    Icon: DistrictLibraryModerateIcon,
    title: 'Introducing District Library Filter',
    body: `This helps easily access relevant content shared district-wide. Additionally, a Certified Content subfolder appears when content from purchased/district collections is available.`,
  },
  [TRACK_IDS.RECOMMENDATIONS_LCB]: {
    Icon: DifferentiatedGroupsModerateIcon,
    title: 'Introducing Differentiated Groups',
    body:
      'We identify groups of students with similar learning needs & suggest materials to help them.',
  },
  [TRACK_IDS.RECOMMENDATIONS_CLASS_PROFILE]: {
    Icon: DifferentiatedGroupsModerateIcon,
    title: 'Plan Targeted Interventions',
    body: buildJoyrideBulletBody(
      'Close learning gaps across your class. Based on mastery data, we:',
      [
        'Group students by performance bands for the selected standard.',
        "Recommend tailored resources to support each group's level. You may Generate AI materials on the spot for targeted reteaching.",
      ]
    ),
  },
  [TRACK_IDS.RECOMMENDATIONS_STUDENT_PROFILE]: {
    Icon: DifferentiatedGroupsModerateIcon,
    title: 'Plan Targeted Interventions',
    body: buildJoyrideBulletBody(
      "Close learning gaps with personalized support. Based on this student's mastery data, we:",
      [
        'Recommend tailored resources aligned to improve mastery of the standard.',
        'You may Generate custom AI materials for immediate 1-on-1 practice.',
      ]
    ),
  },
  [TRACK_IDS.GENAI_DASHBOARD_ILP]: {
    Icon: GenAiModerateIcon,
    title: 'Generate with AI',
    body:
      "Quickly generate a test or lesson deck with a built-in review flow. Just describe what you need, preview and edit the AI's output, and import it when you're ready.",
  },
  [TRACK_IDS.CURRICULUM_PA]: {
    Icon: CurriculumModerateIcon,
    title: 'Introducing Curriculum Hub',
    body: buildJoyrideBulletBody(
      'Connect district pacing with daily instruction.',
      [
        'Admins: Upload and publish official guides to keep schools aligned, and link aligned resources directly to modules.',
        'Teachers: Browse official pacing and sequencing to guide weekly lesson planning.',
      ]
    ),
  },
  [TRACK_IDS.TEST_METADATA_ASSISTANCE]: {
    Icon: GenAiModerateIcon,
    title: 'Introducing Pear Assist',
    body:
      'Create a question & we will suggest standards, DOK levels & difficulty to help you save time.',
  },
  [TRACK_IDS.FOLDER_SHARING]: {
    Icon: GenAiModerateIcon,
    title: 'Share Test Folders',
    body:
      'Share folders with colleagues as Viewer or Editor. Folder sharing does not change test permissions.',
  },
}

export const getModerateTrackContent = (trackId) =>
  MODERATE_TRACK_CONTENT[trackId] ?? null
